import { SVGProps } from 'react';

//TODO: @ matheusgrandi: replace the variants with a prop instead of creating multiple components for the same icon
const ChevronIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 9.67139L12 16.6714L5 9.67139"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const ChevronLeftIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ChevronIcon {...props} style={{ transform: 'rotate(90deg)' }} />
);

export const ChevronRightIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ChevronIcon {...props} style={{ transform: 'rotate(-90deg)' }} />
);

export const ChevronBottomIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ChevronIcon {...props} style={{ transform: 'rotate(180deg)' }} />
);

export const ChevronTopIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ChevronIcon {...props} style={{ transform: 'rotate(0deg)' }} />
);
